//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Importing components
import Bar from './Bar'
import Pie from './Pie'
import SimulateBtn from './SimulateBtn'
import Dropdown from 'react-bootstrap/Dropdown';

import {simulate, downloadViz } from '../../store/actions'
import Card from 'react-bootstrap/Card';


const Simulate = (props, {store}) =>
{
    let theme = store.getState().theme;
    let simDisplay = store.getState().simDisplay;
    let chartSelected = store.getState().chartSelected;
    let userPalette = store.getState().userPalette;
    let userWindow = store.getState().userWindow;
    let chartComponents = {'bar': <Bar />,
                            'pie': <Pie />}

    let dropdownStyle = {fontSize: 10}   
    let dropwdownDivStyle = {marginTop: '-10px',
                            marginBottom: '-10px'}
    return (
    <div id='vizHolder'>
        
        <Card.Body className={`text-center ${theme}`}>
            <button type="button" 
                        className={`btn btn-simulate btn-sm ${theme}`}
                        onClick={() => store.dispatch(simulate())}
                        title='Simulate a bar or a pie chart'>Simulate</button>
        </Card.Body>

        {simDisplay
        ?
        <Card.Footer className={`${theme}`}>
            {(userPalette.length === 0)
            ?
            <p className={`text-center ${theme} simulate-header`}>Click on some colored circles</p>
            :
            <div>
                <div className={`text-center`}>
                    <SimulateBtn />
                </div>
                <Dropdown className={`text-center`}
                            style={dropwdownDivStyle} 
                            title='Download the viz as a jpeg/png'>
                        <Dropdown.Toggle style={dropdownStyle}
                                id="dropdown-basic"
                                className={`dropdown-custom ${theme}`}>
                            <i className={`fa fa-download ${theme}`}></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => store.dispatch(downloadViz(userWindow, theme, chartSelected, 'jpeg'))}>JPEG</Dropdown.Item>
                            <Dropdown.Item onClick={() => store.dispatch(downloadViz(userWindow, theme, chartSelected, 'png'))}>PNG</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                {chartComponents[chartSelected]}
            </div>
            }
        </Card.Footer>
        :
        null}
    </div>
    )
}

Simulate.contextTypes = {
    store: PropTypes.object
}

export default Simulate